import { render, staticRenderFns } from "./Fidelity.vue?vue&type=template&id=6e89b24c&scoped=true"
import script from "./Fidelity.vue?vue&type=script&lang=js"
export * from "./Fidelity.vue?vue&type=script&lang=js"
import style0 from "./Fidelity.vue?vue&type=style&index=0&id=6e89b24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e89b24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
